import { useState, useEffect } from "react";
import { CitaCreate, ActualizarCitasRefuerzo } from "./CitaCreate";
import { CitaUpdateAsociaciones } from "./CitaUpdate";

import { useLoaderData, useLocation } from "react-router-dom";
import Select from "react-select";
import { Who5Draft, Who5Schedule } from "./Who5Create";
import { Scl90Draft, Scl90Schedule } from "./Scl90Create";
import { PsqiDraft, PsqiSchedule } from "./PsqiCreate";
import { MejorateDraft, MejorateSchedule } from "./MejorateCreate";
import { NotificacionScheduleWithAuthor, NotificacionCreateWithAuthor } from "./NotificacionCreate";

import { FormatDate } from "../components/documentacion/FormatDate";

import * as API from "../services/pacientes";
import * as APIESPECIALISTAS from "../services/especialistas";
import * as APITRATAMIENTOS from "../services/tratamientos";
import * as APIDATOSCONSUMO from "../services/datconsumo";


export function CitaNew(props) {
  const {state} = useLocation();

  let dateWithHyphens;
  let d;
  let time;

  if (typeof state !== 'undefined' && state !== null) {
    let {date} = state;
    dateWithHyphens = date.split('T')[0];
    d = new Date(date);
    time = d.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } else {
    dateWithHyphens = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
    d = new Date();
    //time = (d.getHours()<10?'0':'') + d.getHours() + ":" + (d.getMinutes()<10?'0':'') + d.getMinutes();

  }

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const [citaResp, setCitaResp] = useState(props.especialistaFullName);
  const [citaTipo, setCitaTipo] = useState("");
  const [citaPac, setCitaPac] = useState("");
  const [citaFecha, setCitaFecha] = useState(dateWithHyphens);
  const [citaHora, setCitaHora] = useState("");
  const [citaFinFecha, setCitaFinFecha] = useState("");
  const [citaFinHora, setCitaFinHora] = useState("");
  const [citaObs, setCitaObs] = useState("");

  const [pacienteId, setPacienteId] = useState(0);
  const [ultimoTratamiento, setUltimoTratamiento] = useState("");
  //const [especialistaId, setEspecialistaId] = useState(props.especialistaId);

  const [loading, setLoading] = useState(false);
  const [pacienteQuery, setPacienteQuery] = useState("");
  const [pacienteList, setPacienteList] = useState();
  const [pacienteSelect, setPacienteSelect] = useState([]);
  const [especialistaQuery, setEspecialistaQuery] = useState("");
  const [especialistaList, setEspecialistaList] = useState();
  const [especialistaSelect, setEspecialistaSelect] = useState([]);
  const [citaEsp, setCitaEsp] = useState([]);


   // Estados globales para los grupos de sustancias para Test Mejórate
   const [alcoholGroup, setAlcoholGroup] = useState([]);
   const [cocainaGroup, setCocainaGroup] = useState([]);
   const [benzodiacepinasGroup, setBenzodiacepinasGroup] = useState([]);
   const [cannabisGroup, setCannabisGroup] = useState([]);

  // 0. Set initial values for Especialista:
  useEffect(() => {
    // Verificar que props.especialistaId y props.especialistaFullName existan
    if (props.especialistaId && props.especialistaFullName) {
      // Crear el objeto con los valores iniciales
      const initialValues = [{"value": props.especialistaId, "label": props.especialistaFullName}];
      // Establecer los valores iniciales en el estado
      setCitaEsp(initialValues);
    }
  }, [props.especialistaId, props.especialistaFullName]);

  // 1. Get list of users by input query set in React Select
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (props.userRole.includes('administrador')) {
          await API.getSearchPacientes(pacienteQuery).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          await API.getSearchPacientesByEspecialista(pacienteQuery, props.especialistaId).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };

    fetchData();
  }, [pacienteQuery]);

  // 2. Map all Pacientes to create the options for React Select
  useEffect(() => {
    let pacienteSelect;
    if (pacienteList) {
      pacienteSelect = pacienteList?.map((field) => ({
        value: field.id,
        label: field.display_name,
      }));
      setPacienteSelect(pacienteSelect);
    }
  }, [pacienteList]);

  // 3. Get ID value of Paciente Selected
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       if (citaPac) {
  //         setPacienteId(citaPac?.value);
  //         await API.getPacienteByID(citaPac.value).then(
  //           (val) => {
  //             const lastTratamiento = val.meta?.tratamientos?.[val.meta.tratamientos.length - 1];
  //             setUltimoTratamiento(lastTratamiento); // Update state
  //             console.log('Last treatment:', lastTratamiento);
  //           },
  //           (error) => {
  //             console.log(error);
  //           }
  //         );
  //       }
  //     } catch (err) {
  //       console.error('Error fetching data:', err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchData();
  // }, [citaPac]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (citaPac) {
          setPacienteId(citaPac?.value);
          
          // Obtener los datos del paciente
          await API.getPacienteByID(citaPac.value).then(
            async (val) => {
              // Obtener la lista de tratamientos
              const tratamientos = val.meta?.tratamientos;
  
              if (tratamientos && tratamientos.length > 0) {
                // Convertir la lista de tratamientos en un string de IDs separados por coma
                const tratamientoStringList = tratamientos.toString(); // Convertimos cada id a string
  
                // Verificar que el string no esté vacío
                if (tratamientoStringList) {
                  // Llamar a la API con la lista de IDs como string separado por coma
                  const tratamientoData = await APITRATAMIENTOS.getTratamientoByIds(tratamientoStringList);
  
                  // Buscar el tratamiento con la fecha más reciente
                  const latestTratamiento = tratamientoData?.reduce((latest, current) => {
                    if (!latest || new Date(current.meta.fecha) > new Date(latest.meta.fecha)) {
                      return current;
                    }
                    return latest;
                  }, null);

  
                  // Asignar el tratamiento más reciente
                  if (latestTratamiento) {
                    setUltimoTratamiento(latestTratamiento.id);
                    console.log('Último tratamiento:', latestTratamiento.id);
                  } else {
                    console.log('No se encontró un tratamiento con fecha más reciente');
                  }
                } else {
                  console.log('El string de tratamientos está vacío');
                }
              } else {
                console.log('No se encontraron tratamientos');
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [citaPac]);

    // 4. Get list of especialistas by input query set in React Select
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          if (props.userRole.includes('administrador')) {
            await APIESPECIALISTAS.getSearchEspecialistasAndAdmins(especialistaQuery).then(
              (val) => {
                setEspecialistaList(val);
              },
              (error) => {
                console.log(error);
              }
            );
          }
        } catch (err) {
          console.log(err);
        }
        setLoading(false);
      };

      fetchData();
    }, [especialistaQuery]);

    // 5. Map all Especialistas to create the options for React Select
    useEffect(() => {
      let especialistaSelect;
      if (especialistaList) {
          especialistaSelect = especialistaList?.map((field) => ({
            value: field.id,
            label: field.display_name,
          }));
        }
      setEspecialistaSelect(especialistaSelect);
    }, [especialistaList]);

    // // 6. Get ID value of Especialista Selected
    // useEffect(() => {
    //   if (citaEsp) {
    //     setEspecialistaId(citaEsp.value);
    //     setCitaResp(citaEsp.label)
    //   }
    // }, [citaEsp]);

  // 7. Clean values on update tipo de cita
  useEffect(() => {
    if ((citaTipo !== 'ingreso') && (citaTipo !== 'refuerzo')) {
      setCitaFinFecha("");
      setCitaFinHora("");
    }
    if (citaTipo === 'nota') {
      setCitaPac("");
      setPacienteId(0);
    }
  }, [citaTipo]);
  
  // 8. Obtener valores de Datconsumo para test Mejórate
  useEffect(() => {
    // Solo hacer la llamada si citaTipo es 'mejorate' y hay un ultimoTratamiento
    if (citaTipo === 'mejorate' && ultimoTratamiento) {
      const taxId = ultimoTratamiento; // Usar el ID del último tratamiento
  
      // Llamada a la API getAllDatconsumoByTax
      const fetchDatconsumo = async () => {
        try {
          const datconsumoData = await APIDATOSCONSUMO.getAllDatconsumoByTax(taxId);
          if (datconsumoData && datconsumoData.length > 0) {
            // Obtener las sustancias principales
            const principalSustancias = datconsumoData[0].meta.datconsSustRep.filter(sust => sust.nivelimportancia === "principal");

            // Agrupar las sustancias por tipo
            const alcoholTemp = [];
            const cocainaTemp = [];
            const benzodiacepinasTemp = [];
            const cannabisTemp = [];

            principalSustancias.forEach(sustancia => {
              if (["aguardiente", "alcohol", "anis", "cerveza", "champan", "conac", "ginebra", "licor", "ron", "tequila", "vermut", "vino", "vodka", "whisky"].includes(sustancia.sustancia)) {
                alcoholTemp.push(sustancia);
              } else if (["cocaina", "anfetaminas", "metanfetamina"].includes(sustancia.sustancia)) {
                cocainaTemp.push(sustancia);
              } else if (["benzodiacepina", "alprazolam", "diazepam", "lorazepam", "midazolam", "bromazepam", "clordiacepoxido", "clonacepam", "cloracepato", "flunitracepam", "flurazepam", "fluvoxamina", "ketazolam", "lormetazepam", "oxazepam", "zolpidem", "zopiclona"].includes(sustancia.sustancia)) {
                benzodiacepinasTemp.push(sustancia);
              } else if (["cannabis"].includes(sustancia.sustancia)) {
                cannabisTemp.push(sustancia);
              }
            });

            // Actualizar los estados con los grupos de sustancias
            setAlcoholGroup(alcoholTemp);
            setCocainaGroup(cocainaTemp);
            setBenzodiacepinasGroup(benzodiacepinasTemp);
            setCannabisGroup(cannabisTemp);
  
          } else {
            console.log('No se encontraron datos de consumo para el tratamiento');
          }
        } catch (error) {
          console.error('Error al obtener los datos de consumo:', error);
        }
      };

      fetchDatconsumo(); // Ejecutar la llamada a la API
    }
  }, [citaTipo, ultimoTratamiento]); // Dependencias: citaTipo y ultimoTratamiento
  

  const createAndLinkEntries = async (pacienteId, baseDate, tratamientoId) => {
    console.log(pacienteId, baseDate, tratamientoId);
    const createScheduledEntriesForDate = async (date) => {
      const scheduleDate = `${date}T${citaHora}:00`; // Schedule at 10:00 AM
      
      try {
        // Create and schedule who5 entry, notification, and cita
        const who5Entry = await Who5Schedule('Paciente', date, pacienteId, scheduleDate);
        const who5Notification = await NotificacionScheduleWithAuthor(
          pacienteId,
          date,
          `${FormatDate(date)} - Nuevo cuestionario de Bienestar disponible para completar`,
          `/perfil/${tratamientoId}/cuestionarios/who5/${who5Entry.id}/edit`,
          false,
          scheduleDate,
          pacienteId,
          true,
          true
        );
        await CitaCreate(
          '', 'who5', {}, date, citaHora,
          '', '', 'Cuestionario Who5 automático con nuevo tratamiento', pacienteId, {}, who5Entry.id, who5Notification.id
        );
  
        // Create and schedule scl90 entry, notification, and cita
        const scl90Entry = await Scl90Schedule('Paciente', date, pacienteId, scheduleDate);
        const scl90Notification = await NotificacionScheduleWithAuthor(
          pacienteId,
          date,
          `${FormatDate(date)} - Nuevo cuestionario de Síntomas disponible para completar`,
          `/perfil/${tratamientoId}/cuestionarios/scl-90/${scl90Entry.id}/edit`,
          false,
          scheduleDate,
          pacienteId,
          true,
          true
        );
        await CitaCreate(
          '', 'scl90', {}, date, citaHora,
          '', '', `Cuestionario SCL90 automático con nuevo tratamiento`, pacienteId, {}, scl90Entry.id, scl90Notification.id
        );
  
        // Create and schedule psqi entry, notification, and cita
        const psqiEntry = await PsqiSchedule('Paciente', date, pacienteId, scheduleDate);
        const psqiNotification = await NotificacionScheduleWithAuthor(
          pacienteId,
          date,
          `${FormatDate(date)} - Nuevo cuestionario de Sueño disponible para completar`,
          `/perfil/${tratamientoId}/cuestionarios/psqi/${psqiEntry.id}/edit`,
          false,
          scheduleDate,
          pacienteId,
          true,
          true
        );
        await CitaCreate(
          '', 'psqi', {}, date, citaHora,
          '', '', `Cuestionario PSQI automático con nuevo tratamiento`, pacienteId, {}, psqiEntry.id, psqiNotification.id
        );
  
        console.log(`Entries scheduled for date: ${date}`);
      } catch (error) {
        console.error('Error creating entries:', error);
      }
    };
  
    const baseDateObj = new Date(baseDate);
    const datePlus30 = new Date(baseDateObj.setDate(baseDateObj.getDate() + 30)).toISOString().slice(0, 10);
    const datePlus60 = new Date(baseDateObj.setDate(baseDateObj.getDate() + 30)).toISOString().slice(0, 10); 
  
    await createScheduledEntriesForDate(baseDate);
    await createScheduledEntriesForDate(datePlus30);
    await createScheduledEntriesForDate(datePlus60);
  };


  const submitCita = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      // Crear la cita
      const citaVal = await CitaCreate(
        citaResp, citaTipo, citaPac, citaFecha, citaHora, 
        citaFinFecha, citaFinHora, citaObs, pacienteId, citaEsp
      );
      console.log('Cita creada:', citaVal);

      // Si es una cita de tipo refuerzo, actualizar citas relacionadas con cuestionarios
      if (citaTipo === 'refuerzo' && ultimoTratamiento) {
        const resultado = await ActualizarCitasRefuerzo(
          ultimoTratamiento, 
          pacienteId, 
          citaFecha, 
          citaHora
        );
        console.log('Actualización de citas para cuestionarios:', resultado);
      }
  
      if (citaTipo === 'who5' || citaTipo === 'scl90' || citaTipo === 'psqi' || citaTipo === 'mejorate') {
        let cuestionarioVal; // Almacenar el valor de who5 si es creado

        // Determinar si usar NotificacionSchedule o NotificacionCreateWithAuthor
        const scheduledDate = citaFecha && citaHora ? `${citaFecha}T${citaHora}:00` : null;
        const now = new Date();
        const isFutureDate = scheduledDate && new Date(scheduledDate) > now;

        // Crear el cuestionario según el tipo de cita
        let notiUrl, notiText;
        const cleanDate = FormatDate(citaFecha);
        
        if (citaTipo === 'who5') {
          cuestionarioVal = isFutureDate
            ? await Who5Schedule('Paciente', citaFecha, pacienteId, scheduledDate)
            : await Who5Draft('Paciente', citaFecha, pacienteId);
          
          console.log('Entrada WHO5 creada:', cuestionarioVal);
          notiUrl = `/perfil/${ultimoTratamiento}/cuestionarios/who5/${cuestionarioVal.id}/edit`;
          notiText = `${cleanDate} - Nuevo cuestionario de Bienestar disponible para completar`;
        } else if (citaTipo === 'scl90') {
          cuestionarioVal = isFutureDate
            ? await Scl90Schedule('Paciente', citaFecha, pacienteId, scheduledDate)
            : await Scl90Draft('Paciente', citaFecha, pacienteId);
          
          console.log('Entrada SCL90 creada:', cuestionarioVal);
          notiUrl = `/perfil/${ultimoTratamiento}/cuestionarios/scl-90/${cuestionarioVal.id}/edit`;
          notiText = `${cleanDate} - Nuevo cuestionario de Síntomas disponible para completar`;
        } else if (citaTipo === 'psqi') {
          cuestionarioVal = isFutureDate
            ? await PsqiSchedule('Paciente', citaFecha, pacienteId, scheduledDate)
            : await PsqiDraft('Paciente', citaFecha, pacienteId);
          
          console.log('Entrada PSQI creada:', cuestionarioVal);
          notiUrl = `/perfil/${ultimoTratamiento}/cuestionarios/psqi/${cuestionarioVal.id}/edit`;
          notiText = `${cleanDate} - Nuevo cuestionario de Sueño disponible para completar`;
        } else if (citaTipo === 'mejorate') {

          // Ejecutar MejorateSchedule o MejorateDraft para cada grupo
          if (alcoholGroup.length > 0) {
            cuestionarioVal = isFutureDate
              ? await MejorateSchedule(citaFecha, ultimoTratamiento, pacienteId, scheduledDate, "Alcohol")
              : await MejorateDraft(citaFecha, ultimoTratamiento, pacienteId, "Alcohol");
            console.log('Entrada Mejórate para Alcohol creada:', cuestionarioVal);
          }
          if (cocainaGroup.length > 0) {
            cuestionarioVal = isFutureDate
              ? await MejorateSchedule(citaFecha, ultimoTratamiento, pacienteId, scheduledDate, "Cocaína")
              : await MejorateDraft(citaFecha, ultimoTratamiento, pacienteId, "Cocaína");
            console.log('Entrada Mejórate para Cocaína creada:', cuestionarioVal);
          }
          if (benzodiacepinasGroup.length > 0) {
            cuestionarioVal = isFutureDate
              ? await MejorateSchedule(citaFecha, ultimoTratamiento, pacienteId, scheduledDate, "Benzodiazepinas")
              : await MejorateDraft(citaFecha, ultimoTratamiento, pacienteId, "Benzodiazepinas");
            console.log('Entrada Mejórate para Benzodiacepinas creada:', cuestionarioVal);
          }
          if (cannabisGroup.length > 0) {
            cuestionarioVal = isFutureDate
              ? await MejorateSchedule(citaFecha, ultimoTratamiento, pacienteId, scheduledDate, "Cannabis")
              : await MejorateDraft(citaFecha, ultimoTratamiento, pacienteId, "Cannabis");
            console.log('Entrada Mejórate para Cannabis creada:', cuestionarioVal);
          }
          // cuestionarioVal = isFutureDate
          //   ? await MejorateSchedule(citaFecha, ultimoTratamiento, pacienteId, scheduledDate)
          //   : await MejorateDraft(citaFecha, ultimoTratamiento, pacienteId);
          
          // console.log('Entrada Mejórate creada:', cuestionarioVal);
          notiUrl = `/perfil/${ultimoTratamiento}/mejorate/`;
          notiText = `${cleanDate} - Tienes opciones de mejora esperándote`;
        }


        let notification;
      if (cuestionarioVal) {
        notification = isFutureDate
          ? await NotificacionScheduleWithAuthor(
              pacienteId, citaFecha, notiText, notiUrl, false, scheduledDate, pacienteId, true, true
            )
          : await NotificacionCreateWithAuthor(
              pacienteId, citaFecha, notiText, notiUrl, false, pacienteId, true, true
            );
        console.log('Notificación creada:', notification);
      }

        if (notification) { 
          // Execute CitaUpdateAsociaciones if notification is created
          const citaUpdateResult = await CitaUpdateAsociaciones(
            citaVal.id, cuestionarioVal.id, notification.id
          );
          console.log('Cita Actualizada:', citaUpdateResult);
        }
      }

      if (citaTipo === 'ingreso') {
        await createAndLinkEntries(pacienteId, citaFecha, ultimoTratamiento);
      }
  
      // Redirigir después de la creación de la cita
      window.location.replace(`../cita/${citaVal.id}`);
    
    } catch (err) {
      console.error('Error general:', err);
    }
  };
  


  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitCita}>
          <div className='grid--2col'>


            <div className='field'>
              <label htmlFor='citaEsp'>Responsable</label>
              {props.userRole.includes('administrador') ? (
              <div className='control'>
                <Select
                  isMulti
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaEsp'
                  name='citaEsp'
                  required
                  isLoading={loading}
                  options={especialistaSelect}
                  placeholder='Seleccionar Especialista'
                  onInputChange={setEspecialistaQuery}
                  onChange={setCitaEsp}
                />
              </div>
              ) : (
              <div className='control'>
                <input
                  className='input'
                  id='citaEsp'
                  disabled
                  required
                  type='text'
                  value={citaResp}
                />
              </div>
              )}
            </div>

            <div className='field'>
              <label htmlFor='citaTipo'>Tipo de Cita</label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='citaTipo'
                    name='citaTipo'
                    required
                    defaultValue=''
                    onChange={(e) => setCitaTipo(e.target.value)}
                  >
                    {( props.userRole.includes('administrador')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='ingreso'>Ingreso</option>
                      <option value='valoracion'>Valoracion</option>
                      <option value='refuerzo'>Refuerzo</option>
                      <option value='consulta-pre-tratamiento-medica'>Consulta Pre-Tratamiento Médica</option>
                      <option value='consulta-post-tratamiento-medica'>Consulta Post-Tratamiento Médica</option>
                      <option value='consulta-pre-tratamiento-psicologica'>Consulta Pre-Tratamiento Psicológica</option>
                      <option value='consulta-post-tratamiento-psicologica'>Consulta Post-Tratamiento Psicológica</option>
                      <option value='psicoterapia'>Sesión Psicoterapia</option>
                      <option value='nutricion'>Nutrición</option>
                      <option value='entrenamiento'>Entrenamiento</option>
                      <option value='mindfulness'>Mindfulness</option>
                      <option value='nota'>Nota</option>
                      <option value='who5'>Test Who5</option>
                      <option value='psqi'>Test PSQI</option>
                      <option value='scl90'>Test SCL90</option>
                      {/* <option value='mejorate'>Test Mejórate</option> */}
                    </>
                    : ( props.userRole.includes('medicina')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='consulta-pre-tratamiento-medica'>Consulta Pre-Tratamiento Médica</option>
                      <option value='consulta-post-tratamiento-medica'>Consulta Post-Tratamiento Médica</option>
                    </>
                    : ( props.userRole.includes('psicologia')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='consulta-pre-tratamiento-psicologica'>Consulta Pre-Tratamiento Psicológica</option>
                      <option value='consulta-post-tratamiento-psicologica'>Consulta Post-Tratamiento Psicológica</option>
                      <option value='psicoterapia'>Sesión Psicoterapia</option>
                    </>
                    : ( props.userRole.includes('nutricion')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='nutricion'>Nutrición</option>
                    </>
                    : ( props.userRole.includes('entrenamiento')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='entrenamiento'>Entrenamiento</option>
                    </>
                    : ( props.userRole.includes('mindfulness')) ?
                    <>
                      <option disabled value=''>-- Selecciona una opción --</option>
                      <option value='mindfulness'>Mindfulness</option>
                    </>
                    :
                      <option disabled value=''>Sin Permisos</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>

          {(citaTipo !== 'nota') &&

          <div className='field'>
              <label htmlFor='citaPac'>Paciente</label>
              <div className='control'>
                <Select
                  className='basic-multi-select'
                  classNamePrefix='select'
                  id='citaPac'
                  name='citaPac'
                  required
                  isLoading={loading}
                  options={pacienteSelect}
                  placeholder='Seleccionar Paciente'
                  onInputChange={setPacienteQuery}
                  onChange={setCitaPac}
                />
              </div>
            </div>
          }


          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='citaFecha'>Fecha Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFecha'
                  required
                  type='date'
                  value={citaFecha}
                  onChange={(e) => setCitaFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaHora'>Hora Inicio</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaHora'
                  required
                  type='time'
                  value={citaHora}
                  onChange={(e) => setCitaHora(e.target.value)}
                />
              </div>
            </div>

            {((citaTipo === 'ingreso') || (citaTipo === 'refuerzo')) &&
            <>
            <div className='field'>
              <label htmlFor='citaFinFecha'>Fecha Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinFecha'
                  required
                  type='date'
                  value={citaFinFecha}
                  onChange={(e) => setCitaFinFecha(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='citaFinHora'>Hora Final</label>
              <div className='control'>
                <input
                  className='input'
                  id='citaFinHora'
                  required
                  type='time'
                  value={citaFinHora}
                  onChange={(e) => setCitaFinHora(e.target.value)}
                />
              </div>
            </div>
            </>
            }
          </div>
          
          <div className='field'>
            <label htmlFor='citaObs'>Observaciones</label>
            <div className='control'>
              <textarea
                className='textarea'
                name='citaObs'
                id='citaObs'
                value={citaObs}
                onChange={(e) => setCitaObs(e.target.value)}
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={ isCreatingButton}
        >
          { isCreatingButton ? <div className="spinner"></div> : 'Guardar' }
        </button>
      </div>
    </>
  );
}
